import { motion } from "framer-motion";
import {Shield, FileText, AlertTriangle} from 'lucide-react';
import { AnimatedSection } from "../shared/AnimatedSection";
import { Link } from "react-router-dom";

// VERSION: 2.1 - FORZAR RECARGA - Términos Optimizados para Conversión (Última actualización: 2024)
export const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-indigo-900 to-blue-900 py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <Shield className="w-16 h-16 text-indigo-400 mx-auto mb-6" />
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Términos y Condiciones
          </h1>
          <p className="text-xl text-gray-300">
            ᏃꮎꭼᎱꭼꮮ IA™ - Última actualización: {new Date().toLocaleDateString("es-ES")}
          </p>
        </motion.div>

        <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 md:p-12 text-white space-y-8">
          
          {/* Resumen Ejecutivo */}
          <AnimatedSection>
            <div className="bg-gradient-to-br from-indigo-600/30 via-purple-600/30 to-pink-600/30 border-2 border-indigo-400 rounded-2xl p-8 mb-8 shadow-2xl">
              <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 bg-gradient-to-r from-indigo-300 via-purple-300 to-pink-300 bg-clip-text text-transparent">
                ⚡ Resumen Ejecutivo: Lo Que Obtienes Hoy
              </h2>
              
              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="text-center bg-white/5 rounded-xl p-6 hover:bg-white/10 transition-all">
                  <div className="text-5xl font-extrabold text-emerald-400 mb-2">72h</div>
                  <p className="text-gray-300 font-semibold">Implementación Completa</p>
                  <p className="text-sm text-gray-400">Sistema funcionando en 3 días</p>
                </div>
                <div className="text-center bg-white/5 rounded-xl p-6 hover:bg-white/10 transition-all">
                  <div className="text-5xl font-extrabold text-blue-400 mb-2">24/7</div>
                  <p className="text-gray-300 font-semibold">Agente IA Activo</p>
                  <p className="text-sm text-gray-400">Responde mientras duermes</p>
                </div>
                <div className="text-center bg-white/5 rounded-xl p-6 hover:bg-white/10 transition-all">
                  <div className="text-5xl font-extrabold text-purple-400 mb-2">$497</div>
                  <p className="text-gray-300 font-semibold">Inversión Única</p>
                  <p className="text-sm text-gray-400">50% descuento de lanzamiento</p>
                </div>
              </div>

              <div className="bg-black/30 rounded-xl p-6 mb-6">
                <h3 className="text-xl font-bold text-white mb-4 text-center">🎯 Los 7 Diferenciadores Que Nos Hacen ÚNICOS</h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-4 bg-white/5 rounded-lg p-4 hover:bg-white/10 transition-all duration-300 hover:scale-[1.02]">
                    <span className="text-3xl">🚀</span>
                    <div>
                      <p className="font-bold text-emerald-300 text-lg">1. Implementación Express en 72 Horas</p>
                      <p className="text-gray-300 text-sm">Mientras otros tardan semanas, nosotros te entregamos un sistema FUNCIONANDO en 3 días. No teoría, no tutoriales interminables. Resultados inmediatos.</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 bg-white/5 rounded-lg p-4 hover:bg-white/10 transition-all duration-300 hover:scale-[1.02]">
                    <span className="text-3xl">🤖</span>
                    <div>
                      <p className="font-bold text-blue-300 text-lg">2. Agente IA Entrenado Específicamente para TU Negocio</p>
                      <p className="text-gray-300 text-sm">No es un chatbot genérico. Es un SDR virtual que conoce tu oferta, maneja objeciones, califica prospectos y agenda citas con tu tono de voz.</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 bg-white/5 rounded-lg p-4 hover:bg-white/10 transition-all duration-300 hover:scale-[1.02]">
                    <span className="text-3xl">⚡</span>
                    <div>
                      <p className="font-bold text-purple-300 text-lg">3. Respuesta en 0 Segundos (No 5 Minutos)</p>
                      <p className="text-gray-300 text-sm">Los estudios demuestran que responder en los primeros 5 minutos aumenta conversión 400%. Nosotros respondemos al INSTANTE. Tu competencia llega tarde.</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 bg-white/5 rounded-lg p-4 hover:bg-white/10 transition-all duration-300 hover:scale-[1.02]">
                    <span className="text-3xl">🎯</span>
                    <div>
                      <p className="font-bold text-pink-300 text-lg">4. Calificación Automática con IA</p>
                      <p className="text-gray-300 text-sm">El sistema detecta leads calientes vs curiosos. Prioriza automáticamente los prospectos listos para comprar. Tú enfocas tu tiempo solo en cerrar.</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 bg-white/5 rounded-lg p-4 hover:bg-white/10 transition-all duration-300 hover:scale-[1.02]">
                    <span className="text-3xl">🔗</span>
                    <div>
                      <p className="font-bold text-orange-300 text-lg">5. Integraciones Nativas con Meta, Google, LinkedIn</p>
                      <p className="text-gray-300 text-sm">Captura leads de Facebook Ads, Instagram, Google Ads y LinkedIn automáticamente. Un solo CRM para TODO. Adiós al caos de hojas de cálculo.</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 bg-white/5 rounded-lg p-4 hover:bg-white/10 transition-all duration-300 hover:scale-[1.02]">
                    <span className="text-3xl">💬</span>
                    <div>
                      <p className="font-bold text-teal-300 text-lg">6. Nutrición Multi-Canal (WhatsApp + Email)</p>
                      <p className="text-gray-300 text-sm">Secuencias de seguimiento automáticas por WhatsApp y email. Mantén el interés de tus leads sin mover un dedo. El sistema hace el trabajo pesado.</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 bg-white/5 rounded-lg p-4 hover:bg-white/10 transition-all duration-300 hover:scale-[1.02]">
                    <span className="text-3xl">🛡️</span>
                    <div>
                      <p className="font-bold text-emerald-300 text-lg">7. Garantía "Éxito Asegurado" de 30 Días</p>
                      <p className="text-gray-300 text-sm">Si no ves resultados, trabajamos contigo GRATIS hasta lograrlo. No vendemos software y desaparecemos. Tu éxito es nuestro compromiso.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-yellow-500/20 to-orange-500/20 border-2 border-yellow-400 rounded-xl p-6 text-center shadow-lg">
                <p className="text-yellow-300 font-bold text-xl mb-2">⚠️ IMPORTANTE: Esto NO es para todos</p>
                <p className="text-gray-200 leading-relaxed mb-6">
                  Este sistema es para dueños de negocio que están LISTOS para escalar, que valoran su tiempo, y que entienden que automatizar la adquisición de clientes es la diferencia entre crecer o estancarse. Si buscas "lo más barato", hay mil opciones. Si buscas RESULTADOS, sigue leyendo.
                </p>
                <Link to="/#precio" className="inline-block bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-lg font-bold py-4 px-10 rounded-xl shadow-2xl hover:scale-105 transition-transform duration-300">
                  🚀 Ver Planes y Activar Mi Sistema
                </Link>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection>
            <div className="flex items-start gap-4 mb-4">
              <FileText className="w-6 h-6 text-indigo-400 flex-shrink-0 mt-1" />
              <div>
                <h2 className="text-2xl font-bold mb-4">1. Aceptación de Términos</h2>
                <p className="text-gray-300 leading-relaxed mb-4">
                  Al acceder y utilizar los servicios de ᏃꮎꭼᎱꭼꮮ IA™ (en adelante "el Servicio"), usted acepta estar legalmente vinculado por estos Términos y Condiciones. Si no está de acuerdo con alguna parte de estos términos, no debe utilizar nuestros servicios.
                </p>
                <p className="text-gray-300 leading-relaxed">
                  Estos términos se aplican a todos los usuarios del Servicio, incluyendo pero no limitado a: usuarios que son navegadores, clientes, comerciantes, vendedores y/o contribuyentes de contenido.
                </p>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection>
            <h2 className="text-2xl font-bold mb-4">2. El Cambio de Paradigma: De "Software" a "Sistema Llave en Mano"</h2>
            
            <div className="bg-gradient-to-br from-red-500/20 via-orange-500/20 to-yellow-500/20 border-2 border-orange-400 rounded-2xl p-8 mb-8">
              <h3 className="text-3xl font-bold text-orange-300 mb-4 flex items-center gap-3">
                <span className="text-4xl">💥</span> El Problema de la Industria
              </h3>
              <p className="text-gray-200 text-lg leading-relaxed mb-4">
                El mercado está saturado de "soluciones baratas" que te venden una licencia de software y te abandonan. Te prometen automatización, pero lo que obtienes es:
              </p>
              <div className="grid md:grid-cols-3 gap-4 mb-4">
                <div className="bg-red-900/30 border border-red-500/50 rounded-lg p-4">
                  <p className="font-bold text-red-300 mb-2">❌ Curva de aprendizaje brutal</p>
                  <p className="text-sm text-gray-300">Semanas aprendiendo interfaces complicadas</p>
                </div>
                <div className="bg-red-900/30 border border-red-500/50 rounded-lg p-4">
                  <p className="font-bold text-red-300 mb-2">❌ Integración manual</p>
                  <p className="text-sm text-gray-300">Tú conectas todo, tú configuras todo</p>
                </div>
                <div className="bg-red-900/30 border border-red-500/50 rounded-lg p-4">
                  <p className="font-bold text-red-300 mb-2">❌ Soporte inexistente</p>
                  <p className="text-sm text-gray-300">Tickets que tardan días en responder</p>
                </div>
              </div>
              <p className="text-white font-bold text-xl">
                Resultado: Pagas, pierdes tiempo, te frustras, y sigues perdiendo leads.
              </p>
            </div>

            <div className="bg-gradient-to-br from-emerald-500/20 via-green-500/20 to-teal-500/20 border-2 border-emerald-400 rounded-2xl p-8 mb-8">
              <h3 className="text-3xl font-bold text-emerald-300 mb-4 flex items-center gap-3">
                <span className="text-4xl">🚀</span> Nuestra Solución Disruptiva
              </h3>
              <p className="text-gray-200 text-lg leading-relaxed mb-6">
                <strong className="text-white">ᏃꮎꭼᎱꭼꮮ IA™ NO vende software. Entregamos RESULTADOS.</strong> No es una herramienta que debes aprender, es un sistema completamente implementado, configurado y gestionado por nosotros que trabaja para ti desde el primer día.
              </p>
              
              <div className="bg-white/10 rounded-xl p-6 mb-6">
                <h4 className="text-2xl font-bold text-white mb-4">📦 Sistema "Llave en Mano" Incluye:</h4>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="flex items-start gap-3">
                    <span className="text-2xl">✅</span>
                    <div>
                      <p className="font-bold text-white">Implementación Completa en 72h</p>
                      <p className="text-sm text-gray-300">Nosotros instalamos, configuramos y personalizamos TODO</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="text-2xl">✅</span>
                    <div>
                      <p className="font-bold text-white">CRM Pre-configurado</p>
                      <p className="text-sm text-gray-300">Base de datos centralizada lista para usar</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="text-2xl">✅</span>
                    <div>
                      <p className="font-bold text-white">Pipeline de Ventas Optimizado</p>
                      <p className="text-sm text-gray-300">Visualiza cada etapa de tu embudo</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="text-2xl">✅</span>
                    <div>
                      <p className="font-bold text-white">Automatización WhatsApp + Email</p>
                      <p className="text-sm text-gray-300">Secuencias de nutrición pre-escritas y probadas</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="text-2xl">✅</span>
                    <div>
                      <p className="font-bold text-white">1 Agente IA Calificador 24/7</p>
                      <p className="text-sm text-gray-300">Responde, califica y agenda citas mientras duermes</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <span className="text-2xl">✅</span>
                    <div>
                      <p className="font-bold text-white">Integraciones Meta/Google/LinkedIn</p>
                      <p className="text-sm text-gray-300">Captura leads de todas tus campañas automáticamente</p>
                    </div>
                  </div>
                </div>
              </div>

              <p className="text-white font-bold text-xl text-center">
                💎 Funciona como un SDR (Representante de Desarrollo de Ventas) que NUNCA duerme, NUNCA se enferma, y NUNCA pide vacaciones.
              </p>
            </div>

            <div className="bg-gradient-to-r from-purple-500/20 to-pink-500/20 border-2 border-purple-400 rounded-xl p-6">
              <h4 className="text-xl font-bold text-purple-300 mb-3">🎯 Funcionalidades Más Buscadas por Nuestros Clientes:</h4>
              <div className="grid md:grid-cols-2 gap-3 text-gray-200">
                <div className="flex items-center gap-2">
                  <span className="text-emerald-400">●</span>
                  <span><strong>Respuesta instantánea:</strong> 0 segundos de espera para tus leads</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-emerald-400">●</span>
                  <span><strong>Calificación automática:</strong> El IA detecta leads calientes vs fríos</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-emerald-400">●</span>
                  <span><strong>Agendamiento 24/7:</strong> Citas reservadas mientras duermes</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-emerald-400">●</span>
                  <span><strong>Seguimiento persistente:</strong> Nunca más olvides un prospecto</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-emerald-400">●</span>
                  <span><strong>Reportes en tiempo real:</strong> Métricas de conversión al instante</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-emerald-400">●</span>
                  <span><strong>Integración total:</strong> Un solo lugar para gestionar todo</span>
                </div>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection>
            <h2 className="text-2xl font-bold mb-4">3. Planes y Precios</h2>
            
            <div className="bg-gradient-to-br from-blue-500/20 via-purple-500/20 to-pink-500/20 border-2 border-blue-400 rounded-2xl p-8 mb-8">
              <h3 className="text-3xl font-bold text-blue-300 mb-6 text-center">💎 Estructura de Precios Oficial</h3>
              <p className="text-gray-200 text-lg leading-relaxed mb-6 text-center">
                ᏃꮎꭼᎱꭼꮮ IA™ ofrece planes flexibles diseñados para empresas en crecimiento que buscan consolidar sus herramientas de productividad y automatización en una sola plataforma.
              </p>
            </div>

            <div className="space-y-6 text-gray-300">
              {/* Plan Starter */}
              <div className="bg-white/5 rounded-xl p-6 border-2 border-emerald-400/30">
                <h3 className="text-2xl font-bold text-emerald-300 mb-4">📦 Plan Starter</h3>
                <p className="text-gray-300 mb-4">Ideal para emprendedores y pequeñas empresas que inician su transformación digital.</p>
                
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-emerald-500/10 border border-emerald-400/30 rounded-lg p-4">
                    <p className="text-emerald-300 font-bold mb-2">💳 Mensual</p>
                    <p className="text-4xl font-extrabold text-white mb-2">$580 <span className="text-xl text-gray-400">MXN/mes</span></p>
                    <p className="text-sm text-gray-400">Facturación mensual recurrente</p>
                  </div>
                  
                  <div className="bg-emerald-500/10 border border-emerald-400/30 rounded-lg p-4">
                    <p className="text-emerald-300 font-bold mb-2">🎯 Anual (16% descuento)</p>
                    <p className="text-4xl font-extrabold text-white mb-2">$5,800 <span className="text-xl text-gray-400">MXN/año</span></p>
                    <p className="text-sm text-gray-400">Equivalente a $483 MXN/mes</p>
                  </div>
                </div>

                <div className="mt-6 bg-white/5 rounded-lg p-4">
                  <p className="font-bold text-white mb-3">✅ Incluye:</p>
                  <ul className="space-y-2 text-sm">
                    <li>• Plataforma ᏃꮎꭼᎱꭼꮮ IA™ completa con 136+ funcionalidades</li>
                    <li>• 8 herramientas empresariales integradas</li>
                    <li>• CRM + Pipeline de Ventas</li>
                    <li>• Automatización WhatsApp y Email</li>
                    <li>• Soporte técnico estándar</li>
                  </ul>
                  <p className="text-orange-300 font-semibold mt-4">⚠️ Agentes IA NO incluidos (se contratan por separado)</p>
                </div>
              </div>

              {/* Plan Enterprise */}
              <div className="bg-white/5 rounded-xl p-6 border-2 border-purple-400">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-2xl font-bold text-purple-300">🚀 Plan Enterprise</h3>
                  <span className="bg-gradient-to-r from-yellow-400 to-orange-400 text-gray-900 text-xs font-bold px-3 py-1 rounded-full">MÁS POPULAR</span>
                </div>
                <p className="text-gray-300 mb-4">Para empresas que necesitan automatización completa con Agentes IA ilimitados incluidos.</p>
                
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-purple-500/10 border border-purple-400/30 rounded-lg p-4">
                    <p className="text-purple-300 font-bold mb-2">💳 Mensual</p>
                    <p className="text-4xl font-extrabold text-white mb-2">$2,741 <span className="text-xl text-gray-400">MXN/mes</span></p>
                    <p className="text-sm text-emerald-300 font-semibold">TODO INCLUIDO - Sin cargos adicionales</p>
                  </div>
                  
                  <div className="bg-purple-500/10 border border-purple-400/30 rounded-lg p-4">
                    <p className="text-purple-300 font-bold mb-2">🎯 Anual (Ahorra 18%)</p>
                    <p className="text-4xl font-extrabold text-white mb-2">$39,990 <span className="text-xl text-gray-400">MXN/año</span></p>
                    <p className="text-sm text-emerald-300 font-semibold">Equivalente a $3,332.50 MXN/mes</p>
                  </div>
                </div>

                <div className="mt-6 bg-gradient-to-br from-purple-500/20 to-pink-500/20 border border-purple-400/50 rounded-lg p-6">
                  <p className="font-bold text-white mb-3 text-lg">🎁 Incluye TODO del Plan Starter PLUS:</p>
                  <ul className="space-y-2 text-sm">
                    <li>• <strong className="text-emerald-300">Agentes IA Ilimitados</strong> con Uso Ilimitado SIN COSTO adicional</li>
                    <li>• <strong className="text-emerald-300">Mensajes ilimitados</strong> (WhatsApp, Email, SMS)</li>
                    <li>• <strong className="text-emerald-300">Sin wallet</strong> - No pagas por uso variable</li>
                    <li>• Soporte técnico prioritario 24/7</li>
                    <li>• Onboarding personalizado con experto</li>
                    <li>• Actualizaciones y mejoras continuas</li>
                  </ul>
                  <div className="mt-4 bg-yellow-500/20 border border-yellow-400 rounded-lg p-4">
                    <p className="text-yellow-300 font-bold text-center">💰 Valor Agentes IA: $36,660 MXN/año GRATIS</p>
                  </div>
                </div>
              </div>

              {/* Agentes IA Add-on (Plan Starter) */}
              <div className="bg-white/5 rounded-xl p-6 border-2 border-orange-400/30">
                <h3 className="text-xl font-bold text-orange-300 mb-3">🤖 Agentes IA (Add-on para Plan Starter)</h3>
                <p className="text-gray-300 mb-4">Si tienes el Plan Starter y deseas agregar Agentes IA:</p>
                
                <div className="bg-orange-500/10 border border-orange-400/30 rounded-lg p-4">
                  <p className="text-2xl font-bold text-white mb-2">+$2,741 <span className="text-lg text-gray-400">MXN/mes</span></p>
                  <p className="text-sm text-gray-400">Incluye: Agentes IA Ilimitados + Uso Ilimitado</p>
                  <p className="text-emerald-300 text-sm font-semibold mt-2">✅ Mismo precio que contratar Plan Enterprise directamente</p>
                </div>
                
                <div className="mt-4 bg-blue-500/20 border border-blue-400 rounded-lg p-4">
                  <p className="text-blue-300 font-bold mb-2">💡 Recomendación:</p>
                  <p className="text-sm text-gray-300">Si necesitas Agentes IA, es más conveniente contratar directamente el <strong className="text-white">Plan Enterprise</strong> que incluye todo sin cargos adicionales.</p>
                </div>
              </div>

              {/* Cargos Variables */}
              <div className="bg-orange-500/20 border border-orange-400 rounded-xl p-6">
                <h3 className="text-xl font-bold text-orange-300 mb-3">⚠️ Cargos Variables por Uso (Solo Plan Starter)</h3>
                <p className="leading-relaxed mb-4">
                  <strong className="text-white">IMPORTANTE:</strong> El Plan Starter NO incluye cargos variables por uso de servicios de terceros. Los siguientes servicios se facturan según consumo real:
                </p>
                <ul className="list-disc list-inside space-y-2">
                  <li>Mensajes SMS</li>
                  <li>Mensajes de WhatsApp</li>
                  <li>Correos electrónicos masivos</li>
                  <li>Minutos de telefonía VoIP</li>
                  <li>Otros add-ons opcionales</li>
                </ul>
                <div className="mt-4 bg-emerald-500/20 border border-emerald-400 rounded-lg p-4">
                  <p className="text-emerald-300 font-bold mb-2">✅ Plan Enterprise: SIN cargos variables</p>
                  <p className="text-sm text-gray-300">El Plan Enterprise incluye mensajes ilimitados sin costo adicional.</p>
                </div>
              </div>

              {/* Comparativa de Ahorro */}
              <div className="bg-gradient-to-br from-indigo-500/20 via-purple-500/20 to-pink-500/20 border-2 border-indigo-400 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-white mb-6 text-center">💰 Comparativa de Ahorro Anual</h3>
                
                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  <div className="bg-red-900/30 border border-red-500/50 rounded-lg p-6">
                    <p className="text-red-300 font-bold text-lg mb-3 text-center">❌ Stack Fragmentado (Competencia)</p>
                    <p className="text-5xl font-extrabold text-white text-center mb-2">$106,271</p>
                    <p className="text-gray-400 text-center mb-4">MXN/año</p>
                    <ul className="text-sm text-gray-300 space-y-1">
                      <li>• CRM: $12,000/año</li>
                      <li>• Email Marketing: $8,400/año</li>
                      <li>• WhatsApp Business: $18,000/año</li>
                      <li>• Automatización: $15,600/año</li>
                      <li>• Calendario: $3,600/año</li>
                      <li>• Landing Pages: $7,200/año</li>
                      <li>• Agentes IA: $36,660/año</li>
                      <li>• Otros: $4,811.40/año</li>
                    </ul>
                  </div>
                  
                  <div className="bg-emerald-900/30 border border-emerald-500/50 rounded-lg p-6">
                    <p className="text-emerald-300 font-bold text-lg mb-3 text-center">✅ ᏃꮎꭼᎱꭼꮮ IA™ Enterprise Anual</p>
                    <p className="text-5xl font-extrabold text-white text-center mb-2">$39,990</p>
                    <p className="text-gray-400 text-center mb-4">MXN/año</p>
                    <ul className="text-sm text-gray-300 space-y-1">
                      <li>• <strong className="text-white">TODO incluido</strong></li>
                      <li>• 136+ funcionalidades</li>
                      <li>• 8 herramientas empresariales</li>
                      <li>• Agentes IA Ilimitados</li>
                      <li>• Mensajes ilimitados</li>
                      <li>• Sin cargos ocultos</li>
                      <li>• Soporte prioritario 24/7</li>
                    </ul>
                  </div>
                </div>
                
                <div className="bg-gradient-to-r from-yellow-500/30 to-orange-500/30 border-2 border-yellow-400 rounded-xl p-6 text-center">
                  <p className="text-yellow-300 font-bold text-2xl mb-2">🎯 Ahorro Total Anual</p>
                  <p className="text-6xl font-extrabold text-white mb-2">$66,281</p>
                  <p className="text-xl text-gray-300">MXN ahorrados al año</p>
                  <p className="text-emerald-300 font-semibold mt-3">¡62% de ahorro vs competencia!</p>
                </div>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection>
            <h2 className="text-2xl font-bold mb-4">4. Facturación y Pagos</h2>
            
            <div className="space-y-4 text-gray-300">
              <div className="bg-white/5 rounded-xl p-6">
                <p className="leading-relaxed mb-4">
                  <strong className="text-white">4.1 Modalidades de Pago:</strong> ᏃꮎꭼᎱꭼꮮ IA™ ofrece facturación mensual y anual según el plan seleccionado.
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Plan Starter Mensual:</strong> $580 MXN facturados mensualmente de forma recurrente</li>
                  <li><strong>Plan Starter Anual:</strong> $5,800 MXN facturados una vez al año (16% descuento)</li>
                  <li><strong>Plan Enterprise Mensual:</strong> $2,741 MXN facturados mensualmente de forma recurrente</li>
                  <li><strong>Plan Enterprise Anual:</strong> $39,990 MXN facturados una vez al año (18% descuento)</li>
                </ul>
              </div>

              <div className="bg-white/5 rounded-xl p-6">
                <p className="leading-relaxed mb-4">
                  <strong className="text-white">4.2 Ciclo de Facturación:</strong>
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>El primer cargo se realiza al momento de activar la cuenta</li>
                  <li>Los cargos recurrentes se procesan automáticamente en la fecha de renovación</li>
                  <li>Las facturas se envían por correo electrónico dentro de las 24 horas posteriores al cargo</li>
                  <li>Los pagos se procesan mediante tarjeta de crédito/débito o transferencia bancaria</li>
                </ul>
              </div>

              <div className="bg-white/5 rounded-xl p-6">
                <p className="leading-relaxed mb-4">
                  <strong className="text-white">4.3 Cargos Variables (Solo Plan Starter):</strong>
                </p>
                <p className="mb-3">Los cargos por uso de servicios de terceros se facturan mensualmente según consumo real:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Mensajes SMS: Según tarifas del proveedor</li>
                  <li>Mensajes WhatsApp: Según tarifas de WhatsApp Business API</li>
                  <li>Correos electrónicos: Según volumen de envío</li>
                  <li>Minutos de telefonía: Según uso de llamadas VoIP</li>
                </ul>
                <p className="text-emerald-300 font-semibold mt-4">✅ Plan Enterprise: Sin cargos variables. Todo incluido.</p>
              </div>

              <div className="bg-orange-500/20 border border-orange-400 rounded-xl p-6">
                <p className="font-bold text-orange-300 mb-3">⚠️ Importante sobre Métodos de Pago:</p>
                <ul className="list-disc list-inside space-y-2">
                  <li>Se requiere un método de pago válido para activar la cuenta</li>
                  <li>Los pagos fallidos pueden resultar en suspensión temporal del servicio</li>
                  <li>Notificaremos con 7 días de anticipación antes de cada cargo recurrente</li>
                  <li>Aceptamos tarjetas Visa, Mastercard, American Express y transferencias SPEI (México)</li>
                </ul>
              </div>

              <div className="bg-white/5 rounded-xl p-6">
                <p className="leading-relaxed mb-4">
                  <strong className="text-white">4.4 Impuestos:</strong>
                </p>
                <p className="mb-3">Los precios mostrados NO incluyen impuestos aplicables según la jurisdicción del cliente:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>México: IVA 16% se agregará al total</li>
                  <li>Otros países: Impuestos locales aplicables según legislación vigente</li>
                  <li>Las facturas fiscales se emiten conforme a los requisitos legales de cada país</li>
                </ul>
              </div>

              <div className="bg-white/5 rounded-xl p-6">
                <p className="leading-relaxed mb-4">
                  <strong className="text-white">4.5 Cambios de Plan:</strong>
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Upgrade:</strong> Puedes mejorar tu plan en cualquier momento. Se prorratea el costo restante del período actual</li>
                  <li><strong>Downgrade:</strong> Puedes bajar de plan al final del período de facturación actual</li>
                  <li><strong>Anual a Mensual:</strong> No se realizan reembolsos proporcionales. El cambio aplica al finalizar el período anual</li>
                  <li><strong>Mensual a Anual:</strong> Se aplica el descuento anual inmediatamente al realizar el cambio</li>
                </ul>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection>
            <h2 className="text-2xl font-bold mb-4">5. Garantía de Resultados</h2>
            
            <div className="bg-gradient-to-br from-emerald-500/20 via-green-500/20 to-teal-500/20 border-2 border-emerald-400 rounded-2xl p-8 mb-6">
              <h3 className="text-3xl font-bold text-emerald-300 mb-4 text-center">🛡️ Garantía de 90 Días + Optimización Garantizada</h3>
              <p className="text-gray-200 text-lg leading-relaxed text-center mb-6">
                Confiamos tanto en nuestro sistema que ofrecemos una de las garantías más completas de la industria.
              </p>
            </div>

            <div className="space-y-4 text-gray-300">
              <div className="bg-white/5 rounded-xl p-6">
                <p className="leading-relaxed mb-4">
                  <strong className="text-white">5.1 Compromiso de Resultados:</strong> Si después de 90 días de usar el sistema correctamente no has logrado:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4 mb-4">
                  <li>+40% más leads calificados vs tu proceso actual</li>
                  <li>-60% reducción en tiempo de gestión manual</li>
                  <li>Mejora medible en tasa de conversión</li>
                </ul>
                <p className="text-emerald-300 font-bold">Invertiremos $10,000 MXN en optimización de tu cuenta SIN COSTO adicional.</p>
              </div>

              <div className="bg-white/5 rounded-xl p-6">
                <p className="leading-relaxed mb-4">
                  <strong className="text-white">5.2 Qué Incluye la Optimización de $10,000 MXN:</strong>
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Auditoría completa de tu implementación actual</li>
                  <li>Reconfiguración de automatizaciones y flujos</li>
                  <li>Entrenamiento personalizado de Agentes IA</li>
                  <li>Optimización de secuencias de nutrición</li>
                  <li>Ajuste de integraciones con plataformas publicitarias</li>
                  <li>Sesiones de capacitación 1-a-1 con experto</li>
                  <li>Consultoría estratégica de marketing y ventas</li>
                </ul>
              </div>

              <div className="bg-white/5 rounded-xl p-6">
                <p className="leading-relaxed mb-4">
                  <strong className="text-white">5.3 Requisitos de Elegibilidad:</strong>
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Haber implementado correctamente el sistema según especificaciones técnicas</li>
                  <li>Uso activo de la plataforma durante los 90 días completos</li>
                  <li>Mínimo 5 interacciones semanales con leads en el sistema</li>
                  <li>Haber seguido las recomendaciones del equipo de onboarding</li>
                  <li>Documentar resultados con evidencia verificable (reportes CRM, métricas)</li>
                  <li>Inversión mínima en publicidad de $5,000 MXN/mes para generar tráfico</li>
                </ul>
              </div>

              <div className="bg-white/5 rounded-xl p-6">
                <p className="leading-relaxed mb-4">
                  <strong className="text-white">5.4 Definición de "Resultados Medibles":</strong>
                </p>
                <p className="mb-3">Se consideran mejoras cuantificables en las siguientes métricas:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Captura de leads:</strong> Cantidad de contactos nuevos ingresados al CRM</li>
                  <li><strong>Calificación de prospectos:</strong> Porcentaje de leads calificados vs leads totales</li>
                  <li><strong>Citas agendadas:</strong> Número de reuniones/llamadas confirmadas</li>
                  <li><strong>Tasa de respuesta:</strong> Porcentaje de leads que responden vs contactados</li>
                  <li><strong>Tiempo de gestión:</strong> Horas ahorradas en tareas manuales vs proceso anterior</li>
                  <li><strong>Conversión a cliente:</strong> Porcentaje de leads que se convierten en ventas</li>
                </ul>
              </div>

              <div className="bg-white/5 rounded-xl p-6">
                <p className="leading-relaxed mb-4">
                  <strong className="text-white">5.5 Proceso de Activación de Garantía:</strong>
                </p>
                <ol className="list-decimal list-inside space-y-2 ml-4">
                  <li>Enviar solicitud por escrito a <a href="mailto:garantia@zoepelai.com" className="text-indigo-300 hover:underline">garantia@zoepelai.com</a> dentro de los 7 días posteriores al día 90</li>
                  <li>Incluir documentación completa: reportes del CRM, métricas de conversación, capturas de pantalla</li>
                  <li>Proporcionar acceso temporal a la cuenta para auditoría técnica</li>
                  <li>Completar cuestionario de evaluación de uso del sistema</li>
                  <li>Nuestro equipo validará elegibilidad en 5 días hábiles</li>
                  <li>Una vez aprobada, se agenda sesión de optimización en máximo 10 días hábiles</li>
                </ol>
              </div>

              <div className="bg-orange-500/20 border border-orange-400 rounded-xl p-6">
                <p className="font-bold text-orange-300 mb-3">⚠️ Exclusiones de la Garantía:</p>
                <ul className="list-disc list-inside space-y-2">
                  <li>La garantía NO incluye reembolso monetario de suscripciones pagadas</li>
                  <li>NO cubre cargos por uso variable de servicios de terceros</li>
                  <li>NO aplica si el cliente no cumplió con requisitos de uso activo</li>
                  <li>NO aplica si el cliente modificó configuraciones críticas sin autorización del soporte</li>
                  <li>NO cubre resultados afectados por factores externos (crisis económica, cambios regulatorios, etc.)</li>
                </ul>
              </div>

              <div className="bg-emerald-500/20 border border-emerald-400 rounded-xl p-6">
                <p className="font-bold text-emerald-300 mb-3">✅ Compromiso Adicional:</p>
                <p className="leading-relaxed">
                  Más allá de la garantía formal, ᏃꮎꭼᎱꭼꮮ IA™ se compromete a trabajar contigo hasta que logres tus objetivos. Tu éxito es nuestro éxito. Si algo no funciona, lo arreglamos. Si necesitas ajustes, los hacemos. No vendemos software y desaparecemos. Construimos relaciones a largo plazo.
                </p>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection>
            <h2 className="text-2xl font-bold mb-4">6. Agente de IA Calificador - Política de Uso</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              El sistema incluye 1 Agente de IA Calificador que opera 24/7 para responder, calificar y agendar citas con tus leads. El uso del agente está sujeto a nuestra Política de Uso Justo:
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
              <li>El agente debe usarse para fines comerciales legítimos del cliente relacionados con calificación de leads y agendamiento de citas</li>
              <li>Prohibido: minería de datos masiva, scraping, spam, envío masivo no solicitado, o actividades ilegales</li>
              <li>ᏃꮎꭼᎱꭼꮮ IA™ se reserva el derecho de limitar o suspender el servicio en caso de uso abusivo o que viole términos de servicios de terceros (WhatsApp Business API)</li>
              <li>Uso razonable: hasta 10,000 interacciones/mes. Volúmenes superiores requieren aprobación y pueden generar cargos adicionales</li>
              <li>El cliente es responsable de cumplir con regulaciones de privacidad y anti-spam en su jurisdicción</li>
              <li>Actividades que afecten el rendimiento de la plataforma para otros usuarios resultarán en suspensión inmediata</li>
            </ul>
          </AnimatedSection>

          <AnimatedSection>
            <h2 className="text-2xl font-bold mb-4">7. Implementación y Onboarding</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              <strong>7.1 Tiempo de Implementación:</strong> El tiempo estimado de implementación de 72 horas está basado en condiciones estándar y disponibilidad inmediata de la información requerida por parte del cliente.
            </p>
            <p className="text-gray-300 leading-relaxed mb-4">
              <strong>7.2 Responsabilidades del Cliente:</strong> El cliente debe proporcionar en tiempo y forma:
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4 mb-4">
              <li>Accesos a plataformas de terceros (Meta Business, Google Ads, etc.)</li>
              <li>Credenciales y permisos necesarios</li>
              <li>Contenido de marca (logos, textos, imágenes)</li>
              <li>Información de productos/servicios</li>
              <li>Scripts de conversación y flujos deseados</li>
            </ul>
            <p className="text-gray-300 leading-relaxed">
              <strong>7.3 Extensión de Plazo:</strong> Casos complejos, requerimientos especiales, o demoras en la entrega de información por parte del cliente pueden extender el plazo de implementación.
            </p>
          </AnimatedSection>

          <AnimatedSection>
            <h2 className="text-2xl font-bold mb-4">8. Privacidad y Protección de Datos</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              Al utilizar nuestros servicios, usted acepta nuestra Política de Privacidad y el procesamiento de sus datos según las leyes aplicables (GDPR, LFPDPPP México, etc.).
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
              <li>Toda la información proporcionada es confidencial</li>
              <li>Se utiliza exclusivamente para la prestación del servicio contratado</li>
              <li>No vendemos ni compartimos datos con terceros sin consentimiento</li>
              <li>Implementamos medidas de seguridad técnicas y organizativas</li>
              <li>Usted tiene derecho a acceder, rectificar, cancelar u oponerse al tratamiento de sus datos</li>
            </ul>
          </AnimatedSection>

          <AnimatedSection>
            <h2 id="servicios-terceros" className="text-2xl font-bold mb-4">9. Servicios de Terceros</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              La plataforma integra servicios de terceros (WhatsApp Business API, Meta Platforms, Google Ads, etc.) que están sujetos a sus propios términos de servicio.
            </p>
            <div className="bg-red-500/20 border border-red-400 rounded-xl p-6">
              <div className="flex items-start gap-3">
                <AlertTriangle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" />
                <div className="text-gray-300">
                  <p className="font-bold text-white mb-2">Limitación de Responsabilidad:</p>
                  <p>
                    ᏃꮎꭼᎱꭼꮮ IA™ NO se hace responsable por cambios en políticas, tarifas, disponibilidad, o interrupciones de servicios de proveedores externos. Los cambios en APIs o términos de terceros pueden afectar funcionalidades sin previo aviso.
                  </p>
                </div>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection>
            <h2 className="text-2xl font-bold mb-4">10. Limitación de Responsabilidad</h2>
            <div className="bg-yellow-500/20 border border-yellow-400/30 rounded-xl p-6 mb-6">
              <p className="text-yellow-200 font-semibold mb-3">⚠️ Importante: Lee esto antes de contratar</p>
              <p className="text-gray-300 leading-relaxed">
                <strong className="text-white">Somos transparentes:</strong> ᏃꮎꭼᎱꭼꮮ IA™ proporciona un sistema profesional de automatización y gestión de leads, pero <strong className="text-white">NO garantizamos resultados específicos de ventas, conversión, ROI, o cantidad de leads generados.</strong> Tu éxito depende de múltiples factores que están fuera de nuestro control.
              </p>
            </div>

            <p className="text-gray-300 leading-relaxed mb-4">
              <strong>10.1 Resultados No Garantizados:</strong> Entregamos el sistema, las herramientas y el soporte. Tú aportas la estrategia, la inversión publicitaria y el cierre de ventas. Nuestra Garantía "Éxito Asegurado" se enfoca en asegurar que el sistema funcione correctamente, no en garantizar ventas específicas.
            </p>
            <p className="text-gray-300 leading-relaxed mb-4">
              <strong>10.2 Factores Externos que Afectan Resultados:</strong>
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4 mb-4">
              <li><strong>Calidad de leads:</strong> Fuente, targeting, presupuesto publicitario invertido</li>
              <li><strong>Industria y competencia:</strong> Saturación del mercado, estacionalidad, ciclo de venta</li>
              <li><strong>Estrategia de marketing:</strong> Oferta, propuesta de valor, copywriting, creativos</li>
              <li><strong>Habilidades del equipo:</strong> Capacidad de cierre, seguimiento, manejo de objeciones</li>
              <li><strong>Inversión publicitaria:</strong> Presupuesto mensual en Meta Ads, Google Ads, LinkedIn</li>
              <li><strong>Condiciones económicas:</strong> Recesión, poder adquisitivo, confianza del consumidor</li>
            </ul>
            <p className="text-gray-300 leading-relaxed mb-4">
              <strong>10.3 Daños Indirectos:</strong> En ningún caso ᏃꮎꭼᎱꭼꮮ IA™ será responsable por daños indirectos, incidentales, especiales, consecuentes o punitivos, incluyendo pérdida de beneficios, datos, uso, o goodwill.
            </p>
            <p className="text-gray-300 leading-relaxed">
              <strong>10.4 Límite Máximo:</strong> Nuestra responsabilidad total no excederá el monto pagado por el cliente en los últimos 12 meses del servicio.
            </p>
          </AnimatedSection>

          <AnimatedSection>
            <h2 className="text-2xl font-bold mb-4">11. Propiedad Intelectual</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              <strong>11.1 Marca:</strong> ᏃꮎꭼᎱꭼꮮ IA™ es una marca registrada. Todos los derechos reservados.
            </p>
            <p className="text-gray-300 leading-relaxed mb-4">
              <strong>11.2 Software:</strong> El software, código, algoritmos, y tecnología de IA son propiedad exclusiva de ᏃꮎꭼᎱꭼꮮ IA™.
            </p>
            <p className="text-gray-300 leading-relaxed">
              <strong>11.3 Datos del Cliente:</strong> Usted retiene todos los derechos sobre sus datos, contenido, y propiedad intelectual. Le otorgamos una licencia limitada para usar nuestra plataforma.
            </p>
          </AnimatedSection>

          <AnimatedSection>
            <h2 className="text-2xl font-bold mb-4">12. Cancelación y Reembolsos</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              <strong>12.1 Cancelación por el Cliente:</strong> Puede cancelar su suscripción en cualquier momento desde su panel de control. La cancelación será efectiva al final del período de facturación actual.
            </p>
            <p className="text-gray-300 leading-relaxed mb-4">
              <strong>12.2 No Reembolsos Proporcionales:</strong> No se realizan reembolsos proporcionales por cancelaciones anticipadas, excepto según lo establecido en la Garantía de Satisfacción (Sección 5).
            </p>
            <p className="text-gray-300 leading-relaxed">
              <strong>12.3 Cancelación por ᏃꮎꭼᎱꭼꮮ IA™:</strong> Nos reservamos el derecho de suspender o cancelar cuentas por violación de estos términos, uso fraudulento, o actividades ilegales.
            </p>
          </AnimatedSection>

          <AnimatedSection>
            <h2 className="text-2xl font-bold mb-4">13. Modificaciones de Términos</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              ᏃꮎꭼᎱꭼꮮ IA™ se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. Los cambios significativos serán notificados con al menos 30 días de antelación por correo electrónico.
            </p>
            <p className="text-gray-300 leading-relaxed">
              El uso continuado del Servicio después de la notificación de cambios constituye su aceptación de los nuevos términos.
            </p>
          </AnimatedSection>

          <AnimatedSection>
            <h2 className="text-2xl font-bold mb-4">14. Ley Aplicable y Jurisdicción</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              Estos Términos y Condiciones se rigen por las leyes de los Estados Unidos Mexicanos. Cualquier disputa se resolverá en los tribunales competentes de la Ciudad de México.
            </p>
          </AnimatedSection>

          <AnimatedSection>
            <h2 className="text-2xl font-bold mb-4">15. Información de Contacto</h2>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-indigo-500/20 border border-indigo-400 rounded-xl p-6">
                <p className="text-white font-semibold text-lg mb-3">📧 Departamento Legal</p>
                <p className="text-gray-300 mb-2">Para consultas sobre términos, condiciones y políticas:</p>
                <p className="text-gray-300">Email: <a href="mailto:legal@zoepelai.com" className="text-indigo-300 hover:text-indigo-200 underline">legal@zoepelai.com</a></p>
                <p className="text-gray-400 text-sm mt-2">Respuesta en 48-72 horas hábiles</p>
              </div>

              <div className="bg-emerald-500/20 border border-emerald-400 rounded-xl p-6">
                <p className="text-white font-semibold text-lg mb-3">🛡️ Garantías y Reclamaciones</p>
                <p className="text-gray-300 mb-2">Para activar garantía de 90 días:</p>
                <p className="text-gray-300">Email: <a href="mailto:garantia@zoepelai.com" className="text-emerald-300 hover:text-emerald-200 underline">garantia@zoepelai.com</a></p>
                <p className="text-gray-400 text-sm mt-2">Respuesta en 5 días hábiles</p>
              </div>

              <div className="bg-purple-500/20 border border-purple-400 rounded-xl p-6">
                <p className="text-white font-semibold text-lg mb-3">💬 Soporte Técnico</p>
                <p className="text-gray-300 mb-2">Para asistencia técnica y consultas de uso:</p>
                <p className="text-gray-300">Email: <a href="mailto:soporte@zoepelai.com" className="text-purple-300 hover:text-purple-200 underline">soporte@zoepelai.com</a></p>
                <p className="text-gray-400 text-sm mt-2">Respuesta en 24 horas (Plan Starter) / 4 horas (Plan Enterprise)</p>
              </div>

              <div className="bg-blue-500/20 border border-blue-400 rounded-xl p-6">
                <p className="text-white font-semibold text-lg mb-3">💼 Ventas y Consultoría</p>
                <p className="text-gray-300 mb-2">Para contratar o consultas comerciales:</p>
                <p className="text-gray-300">Email: <a href="mailto:ventas@zoepelai.com" className="text-blue-300 hover:text-blue-200 underline">ventas@zoepelai.com</a></p>
                <p className="text-gray-400 text-sm mt-2">Respuesta en 12 horas hábiles</p>
              </div>
            </div>

            <div className="mt-6 bg-white/5 rounded-xl p-6">
              <p className="text-white font-semibold mb-3">🏢 Información Corporativa</p>
              <p className="text-gray-300 mb-2"><strong>Razón Social:</strong> ᏃꮎꭼᎱꭼꮮ IA™ (Marca registrada)</p>
              <p className="text-gray-300 mb-2"><strong>Domicilio Fiscal:</strong> Ciudad de México, México</p>
              <p className="text-gray-300 mb-2"><strong>RFC:</strong> Disponible bajo solicitud para facturación</p>
              <p className="text-gray-300"><strong>Horario de Atención:</strong> Lunes a Viernes, 9:00 AM - 6:00 PM (Hora del Centro de México)</p>
            </div>
          </AnimatedSection>

          {/* CTA Final */}
          <AnimatedSection>
            <div className="bg-gradient-to-br from-indigo-600/30 via-purple-600/30 to-pink-600/30 border-2 border-indigo-400 rounded-2xl p-10 text-center">
              <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                ¿Listo para Transformar Tu Negocio?
              </h3>
              <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto">
                Activa tu sistema de adquisición de clientes IA en 72 horas. Implementación completa, CRM configurado, y tu Agente IA trabajando 24/7.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/#precio" className="inline-block bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-lg font-bold py-4 px-10 rounded-xl shadow-2xl hover:scale-105 transition-transform duration-300">
                  🚀 Ver Planes y Precios
                </Link>
                <Link to="/" className="inline-block bg-white/10 border-2 border-white/30 text-white text-lg font-bold py-4 px-10 rounded-xl hover:bg-white/20 transition-all duration-300">
                  ← Volver al Inicio
                </Link>
              </div>
            </div>
          </AnimatedSection>

          <div className="border-t border-white/20 pt-8 mt-12">
            <p className="text-center text-gray-400 text-sm">
              Última actualización: {new Date().toLocaleDateString("es-ES", { year: "numeric", month: "long", day: "numeric" })}
            </p>
            <p className="text-center text-gray-400 text-sm mt-2">
              © {new Date().getFullYear()} ᏃꮎꭼᎱꭼꮮ IA™. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
